import { __assign } from 'tslib';
import { animations } from '../../motion/features/animations.mjs';
import { gestureAnimations } from '../../motion/features/gestures.mjs';
import { createDomVisualElement } from './create-visual-element.mjs';

/**
 * @public
 */
var domAnimation = __assign(__assign({ renderer: createDomVisualElement }, animations), gestureAnimations);

export { domAnimation };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs
// module id = l5sb
// module chunks = 0